import { Box } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
export default function VideoModel({ url }) {
  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
      <Box 
        component="iframe"
        src={url.replace("/view?usp=sharing", "/preview")}
        title="Embedded video preview"
        allow="autoplay; fullscreen"
        allowFullScreen
        sx={{ width: "100%", height: "100%" }}
        className="test"
      />
    </Box>
  );
}

VideoModel.propTypes = {
  url: PropTypes.string.isRequired,
};